/*
THIS INFRAGISTICS ULTIMATE SOFTWARE LICENSE  AGREEMENT ("AGREEMENT") LOCATED HERE:
https://www.infragistics.com/legal/license/igultimate-la
https://www.infragistics.com/legal/license/igultimate-eula
GOVERNS THE LICENSING, INSTALLATION AND USE OF INFRAGISTICS SOFTWARE. BY DOWNLOADING AND/OR INSTALLING AND USING INFRAGISTICS SOFTWARE:  you are indicating that you have read and understand this Agreement, and agree to be legally bound by it on behalf of the yourself and your company.
*/
import { IDataSourceDataProvider_$type } from "./IDataSourceDataProvider";
import { IDataSourceSupportsIndexedAccess_$type } from "./IDataSourceSupportsIndexedAccess";
import { Type } from "./type";
/**
 * @hidden
 */
export var IDataSourceLocalDataProvider_$type = /*@__PURE__*/ new Type(null, 'IDataSourceLocalDataProvider', null, [IDataSourceDataProvider_$type, IDataSourceSupportsIndexedAccess_$type]);
//# sourceMappingURL=IDataSourceLocalDataProvider.js.map
